<template>
  <div>

     <data-table
        ref="permittable"
        table-ref="permittable"

        title="Permits"
        icon="fa fa-clipboard"

        :url="'/permits/site/' + rowData.id + (this.telcoId ? '/org/' + this.telcoId : '')"

        :fields="fields"

        :add-action="isManager('project|maintenance|finance|property|admin') ? action : null"
        :add-props="addProps"

        detail-component="permits-detail-row" />

<!--    <site-permit-to-work :row-data="rowData" /> -->

     <hr />

      <site-progress :row-data="rowData" />

  </div>

</template>


<script>
import Vue from 'vue'

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import {settings} from '@/components/Data'

import SiteProgress from '@/components/sites/SiteProgress'

import PermitAction from '@/components/actions/PermitAction'
import PermitDetails from '@/components/sites/permits/PermitDetails'
import PermitControls from '@/components/sites/permits/PermitControls'

import SitePermitToWork from '@/components/sites/permits/SitePermitToWork'


Vue.component('permits-detail-row', PermitDetails)
Vue.component('permit-controls', PermitControls)

export default {

  mixins: [DateMixins, NumberMixins],


  components: {
    PermitControls,
    PermitAction,
    SitePermitToWork,
    SiteProgress
  },


  props: {

    rowData: {
      type: Object,
      required: true
    },

    editMode: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }


  },



  data () {

    return {

      telcoId: this.isTelco() ? Number(this.org().id) : null,
      action: PermitAction,

      addProps: {
        rowData: this.rowData,
        editMode: true,
        readOnly: this.readOnly,
        siteId: this.rowData.id
      },

      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'permitType',
          title: 'Type',
          sortField: 'permitType'
        },
        {
          name: 'applied',
          title: 'Applied',
          callback: this.formatDate,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'issued',
          title: 'Issued',
          callback: this.formatDate,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'expiry',
          title: 'Expiry',
          callback: this.formatDate
        },
        {
          name: 'amount',
          title: 'Amount',
          callback: this.formatNumber
        },
        {
          name: 'renewalPeriod',
          title: 'Period',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'ref1',
          title: settings.ref1Label,
          sortField: 'ref1',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'ref2',
          title: settings.ref2Label,
          sortField: 'ref2',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: '__component:permit-controls',
          title: ''
        }
      ]
    }

  }

}

</script>



// WEBPACK FOOTER //
// SitePermits.vue?2302065f